// src/api/modules/BoxApi.js
import Methods from "../methods";

const searchAvailableBoxes = (context, idClient, process, payload) => {
  const {filters, page, size, sortBy = "registrationDate", direction = "desc"} = payload;
  const url = `boxes/available/${idClient}/${process}/?page=${page}&size=${size}&sortBy=${sortBy}&direction=${direction}`;
  return Methods.doPost(context, url, filters, null);
};

const searchBoxesBulk = (context, payload) => {
  const {idClient, type, file} = payload;
  const formData = new FormData();
  formData.append("file", file);

  const url = `/boxes/bulk-search/${idClient}/${type}`;
  return Methods.doPostMultipart(context, url, formData);
};

export default {
  searchAvailableBoxes,
  searchBoxesBulk,
};



// WEBPACK FOOTER //
// ./src/api/modules/BoxApi.js